import React from "react";

const defaultInitiativeData = [
  {
    initiative: "",
    details: "",
    outcome: "",
  },
];

const InitiativeOutcomeTable = ({ initiativeData, setInitiativeData }) => {
  const handleChange = (index, field, value) => {
    const updated = [...initiativeData];
    updated[index][field] = value;
    setInitiativeData(updated);
  };

  const addRow = () => {
    setInitiativeData([
      ...initiativeData,
      {
        initiative: "",
        details: "",
        outcome: "",
      },
    ]);
  };

  const removeRow = () => {
    if (initiativeData.length > 1) {
      setInitiativeData(initiativeData.slice(0, -1));
    }
  };

  const cell = {
    border: "1px solid #000",
    padding: "20px",
  };

  const header = {
    ...cell,
    backgroundColor: "#d3c9ce",
    fontWeight: "bold",
    textAlign: "center",
  };

  const inputStyle = {
    width: "100%",
    border: "1px solid #000",
    padding: "15px",
  };

  const addButtonStyle = {
    backgroundColor: "white",
    border: "1px solid lightgrey",
    color: "grey",
    borderRadius: "4px",
    padding: "8px 12px",
    cursor: "pointer",
  };

  const removeButtonStyle = {
    backgroundColor: "white",
    border: "1px solid lightgrey",
    color: "grey",
    borderRadius: "4px",
    padding: "8px 12px",
    cursor: "pointer",
  };

  return (
    <div>
      <div
        style={{
          overflowX: "auto",
          marginTop: 20,
          border: "1px solid #000",
          overflow: "hidden",
          borderRadius: "8px",
        }}
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={header}>S. No</th>
              <th style={header}>Initiative undertaken</th>
              <th style={header}>
                Details of the initiative
                <br />
                <small>
                  (Web-link, if any, may be provided along-with summary)
                </small>
              </th>
              <th style={header}>Outcome of the initiative</th>
            </tr>
          </thead>
          <tbody>
            {initiativeData.map((row, index) => (
              <tr key={index}>
                <td style={cell}>{index + 1}.</td>
                <td style={cell}>
                  <textarea
                    placeholder="Initiatives"
                    value={row.initiative}
                    onChange={(e) =>
                      handleChange(index, "initiative", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <textarea
                    placeholder="Details"
                    value={row.details}
                    onChange={(e) =>
                      handleChange(index, "details", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <textarea
                    placeholder="Outcome"
                    value={row.outcome}
                    onChange={(e) =>
                      handleChange(index, "outcome", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "10px",
          gap: "10px",
        }}
      >
        <button onClick={removeRow} style={removeButtonStyle}>
          - Remove
        </button>
        <button onClick={addRow} style={addButtonStyle}>
          + Add More
        </button>
      </div>
    </div>
  );
};

export default InitiativeOutcomeTable;
